var map = {
	"./Ellipse-1.png": 19982,
	"./Ellipse-2.png": 90341,
	"./Group 13153.png": 69038,
	"./Group 1813.png": 79068,
	"./Rectangl.png": 89638,
	"./Rectangl11.png": 16224,
	"./Rectangle2.png": 55135,
	"./Rectangle22.png": 68637,
	"./Rectangle3.png": 58198,
	"./Rectangle33.png": 90847,
	"./Rectangle34 (2).png": 38627,
	"./Rectangle34.png": 39520,
	"./Rectangle4.png": 98281,
	"./Rectangle4143.png": 1115,
	"./Rectangle_415.png": 48922,
	"./Rectangle_4152.png": 79634,
	"./about/about-1.jpg": 63981,
	"./about/about-2.svg": 46334,
	"./about/about-3.jpg": 51839,
	"./about/about-4.jpg": 49876,
	"./about/about-5.jpg": 28401,
	"./aero-img.png": 98229,
	"./apple-icon.png": 87658,
	"./auth/auth-1.svg": 30271,
	"./avatar/avatar-21.jpg": 2413,
	"./avatar/avatar-22.jpg": 33186,
	"./avatar/avatar-23.jpg": 24895,
	"./avatar/avatar-24.jpg": 30260,
	"./avatar/avatar-25.jpg": 18417,
	"./avatar/avatar-26.jpg": 86214,
	"./avatar/avatar-27.jpg": 76323,
	"./avatar/avatar-28.jpg": 18712,
	"./avatar/avatar1.jpg": 9502,
	"./avatar/avatar10.jpg": 46820,
	"./avatar/avatar11.jpg": 41217,
	"./avatar/avatar12.jpg": 35286,
	"./avatar/avatar13.jpg": 98451,
	"./avatar/avatar14.jpg": 27520,
	"./avatar/avatar15.jpg": 83101,
	"./avatar/avatar16.jpg": 73202,
	"./avatar/avatar17.jpg": 41135,
	"./avatar/avatar18.jpg": 90188,
	"./avatar/avatar19.jpg": 35561,
	"./avatar/avatar2.jpg": 83209,
	"./avatar/avatar20.jpg": 16693,
	"./avatar/avatar3.jpg": 37836,
	"./avatar/avatar4.jpg": 92183,
	"./avatar/avatar5.jpg": 97722,
	"./avatar/avatar6.jpg": 20325,
	"./avatar/avatar7.jpg": 57960,
	"./avatar/avatar8.jpg": 46099,
	"./avatar/avatar9.jpg": 82934,
	"./ban-bg.png": 77557,
	"./bank-image.png": 88314,
	"./banner-background-img-1.png": 41781,
	"./banner-background-img-2.png": 5054,
	"./banner-img (2).png": 47279,
	"./banner-img-1.png": 15410,
	"./banner-img-2.png": 80553,
	"./banner-img-3.png": 25728,
	"./banner-img-4.png": 84383,
	"./banner-img-5.png": 6294,
	"./banner-img.png": 25676,
	"./banner.png": 80758,
	"./banner/ban-shape-2.svg": 25159,
	"./banner/ban-shape-3.svg": 21686,
	"./banner/banner-bg-01.png": 26685,
	"./banner/banner-bg-02.png": 42918,
	"./banner/banner-book.png": 38039,
	"./banner/banner-text-bg.png": 65705,
	"./banner/soft-star.png": 28922,
	"./banner/star-01.png": 30999,
	"./banner/star-02.png": 7068,
	"./banner/star-03.png": 59333,
	"./banner/star-04.png": 88906,
	"./banner/star-05.png": 4467,
	"./become-01.png": 86255,
	"./become-02.png": 64788,
	"./best-course-img-1.jpg": 83698,
	"./best-course-img-2.jpg": 37853,
	"./best-course-img-3.jpg": 69760,
	"./bg-banner-01.png": 12052,
	"./bg-banner-02.png": 33519,
	"./bg-banner.png": 42274,
	"./bg/about-bg-01.png": 11079,
	"./bg/about-bg-02.png": 60396,
	"./bg/arrow.png": 16555,
	"./bg/ban-bg.png": 92627,
	"./bg/banner-vector.svg": 92816,
	"./bg/benefit-bg.png": 74505,
	"./bg/bg-1.png": 51817,
	"./bg/bg-10.png": 1581,
	"./bg/bg-11.png": 38340,
	"./bg/bg-12.png": 23615,
	"./bg/bg-13.png": 69814,
	"./bg/bg-14.png": 19785,
	"./bg/bg-15.png": 95584,
	"./bg/bg-16.png": 93147,
	"./bg/bg-17.png": 71602,
	"./bg/bg-18.png": 757,
	"./bg/bg-19.png": 89132,
	"./bg/bg-2.png": 3634,
	"./bg/bg-20.png": 87912,
	"./bg/bg-21.svg": 53147,
	"./bg/bg-22.svg": 71784,
	"./bg/bg-3.png": 25179,
	"./bg/bg-4.png": 70372,
	"./bg/bg-5.png": 33613,
	"./bg/bg-6.png": 1846,
	"./bg/bg-7.png": 55647,
	"./bg/bg-8.png": 92232,
	"./bg/bg-9.png": 40625,
	"./bg/bg-footer.jpg": 47051,
	"./bg/blog-bg.png": 94740,
	"./bg/book-bg.png": 34717,
	"./bg/breadcrumb-bar.png": 48825,
	"./bg/card-bg-01.png": 24028,
	"./bg/card-bg-02.png": 47959,
	"./bg/card-bg-03.png": 48462,
	"./bg/card-bg-04.png": 46945,
	"./bg/category-bg-1.png": 85654,
	"./bg/category-bg.png": 4840,
	"./bg/count-icon.png": 44107,
	"./bg/faq-bg.png": 33078,
	"./bg/feature-bg-01.png": 68214,
	"./bg/feature-bg-02.png": 82189,
	"./bg/footer-bg-01.png": 33047,
	"./bg/footer-bg-02.png": 74940,
	"./bg/footer-left.svg": 79047,
	"./bg/footer-right.svg": 78338,
	"./bg/home-left.png": 2137,
	"./bg/home-main.png": 92609,
	"./bg/home-middle.png": 13165,
	"./bg/home-right-bottom.png": 23624,
	"./bg/home-right.png": 15074,
	"./bg/instructor-bg-1.png": 24661,
	"./bg/instructor-bg.png": 16371,
	"./bg/instructor-vector-left.svg": 33853,
	"./bg/instructor-vector-right.svg": 3552,
	"./bg/map-bg.png": 93852,
	"./bg/map-user.png": 62791,
	"./bg/map.png": 6098,
	"./bg/master-vector-left.svg": 30146,
	"./bg/patter-one.png": 465,
	"./bg/pattern-01.png": 47876,
	"./bg/pattern-02.png": 33151,
	"./bg/pattern-03.png": 79350,
	"./bg/pattern-04.png": 29321,
	"./bg/pattern-05.svg": 96180,
	"./bg/pattern-06.svg": 44391,
	"./bg/pattern-left.png": 93174,
	"./bg/pattern-right.png": 20011,
	"./bg/profile-bg.jpg": 17543,
	"./bg/quote.svg": 74414,
	"./bg/role-bg-01.png": 11022,
	"./bg/role-bg-02.png": 13445,
	"./bg/shape-04.svg": 93362,
	"./bg/shape-05.svg": 31299,
	"./bg/shape-1.png": 48433,
	"./bg/shape-2.png": 88538,
	"./bg/shape-owel.svg": 99571,
	"./bg/skill-icon-01.png": 61409,
	"./bg/skill-icon-02.png": 12426,
	"./bg/skill-icon-03.png": 63187,
	"./bg/slide-left.svg": 63941,
	"./bg/subscribe-bg-01.png": 81268,
	"./bg/subscribe-bg.png": 90594,
	"./bg/testimonials-bg.jpg": 15116,
	"./bg/vector-layer-one.png": 41740,
	"./bg/vector-layer-three.png": 23532,
	"./bg/vector-layer-two.png": 12014,
	"./blog-banner.jpg": 51133,
	"./blog/blog-01.jpg": 63373,
	"./blog/blog-02.jpg": 94146,
	"./blog/blog-03.jpg": 85855,
	"./blog/blog-04.jpg": 7572,
	"./blog/blog-05.jpg": 79377,
	"./blog/blog-06.jpg": 63526,
	"./blog/blog-07.jpg": 53635,
	"./blog/blog-08.jpg": 96024,
	"./blog/blog-09.jpg": 341,
	"./blog/blog-1.jpg": 61759,
	"./blog/blog-10.jpg": 82255,
	"./blog/blog-11.jpg": 9874,
	"./blog/blog-12.jpg": 19773,
	"./blog/blog-13.jpg": 68640,
	"./blog/blog-14.jpg": 51475,
	"./blog/blog-15.jpg": 65014,
	"./blog/blog-16.jpg": 35361,
	"./blog/blog-17.jpg": 57316,
	"./blog/blog-18.jpg": 31735,
	"./blog/blog-19.jpg": 67898,
	"./blog/blog-2.jpg": 77424,
	"./blog/blog-20.jpg": 52938,
	"./blog/blog-21.jpg": 48743,
	"./blog/blog-22.jpg": 15896,
	"./blog/blog-23.jpg": 77077,
	"./blog/blog-24.jpg": 40014,
	"./blog/blog-25.jpg": 19499,
	"./blog/blog-26.jpg": 94332,
	"./blog/blog-27.jpg": 38681,
	"./blog/blog-28.jpg": 9410,
	"./blog/blog-29.jpg": 22079,
	"./blog/blog-3.jpg": 78349,
	"./blog/blog-30.jpg": 82913,
	"./blog/blog-31.jpg": 9316,
	"./blog/blog-32.jpg": 51891,
	"./blog/blog-33.jpg": 7126,
	"./blog/blog-34.jpg": 13469,
	"./blog/blog-35.jpg": 61728,
	"./blog/blog-36.jpg": 52047,
	"./blog/blog-37.jpg": 75666,
	"./blog/blog-38.jpg": 42025,
	"./blog/blog-39.jpg": 44236,
	"./blog/blog-4.jpg": 96902,
	"./blog/blog-40.jpg": 44668,
	"./blog/blog-41.jpg": 65721,
	"./blog/blog-42.jpg": 58606,
	"./blog/blog-5.jpg": 19075,
	"./blog/blog-6.jpg": 40948,
	"./blog/blog-7.jpg": 38321,
	"./blog/blog-8.jpg": 76266,
	"./blog/blog-9.jpg": 88423,
	"./blog/blog-detail-image.jpg": 91267,
	"./blog/blog-img-01.jpg": 86347,
	"./blog/blog-img-02.jpg": 94364,
	"./blog/blog-img-03.jpg": 15417,
	"./blog/image-8.jpg": 54509,
	"./blog/image-9.jpg": 69936,
	"./blog/recent-blog-1.jpg": 91973,
	"./blog/recent-blog-2.jpg": 69370,
	"./blog/recent-blog-3.jpg": 80183,
	"./blur.png": 29635,
	"./career-img-1.png": 13894,
	"./career-img-2.png": 95101,
	"./categories-icon-01.png": 83390,
	"./categories-icon-02.png": 69141,
	"./categories-icon-03.png": 86252,
	"./categories-icon-04.png": 16419,
	"./categories-icon-05.png": 94842,
	"./categories-icon.png": 86080,
	"./category-bg.png": 29014,
	"./category/category-01.jpg": 48453,
	"./category/category-02.jpg": 25850,
	"./category/category-03.jpg": 89687,
	"./category/category-04.jpg": 8492,
	"./category/category-05.jpg": 46537,
	"./category/category-06.jpg": 3454,
	"./category/category-07.jpg": 34939,
	"./category/category-08.jpg": 26592,
	"./category/category-09.jpg": 77725,
	"./category/category-1.jpg": 52903,
	"./category/category-1.svg": 30123,
	"./category/category-10.jpg": 89511,
	"./category/category-11.jpg": 50506,
	"./category/category-12.jpg": 17845,
	"./category/category-13.jpg": 10584,
	"./category/category-14.jpg": 33419,
	"./category/category-15.jpg": 6958,
	"./category/category-16.jpg": 79449,
	"./category/category-17.jpg": 65724,
	"./category/category-18.jpg": 93471,
	"./category/category-19.jpg": 73474,
	"./category/category-2.jpg": 72920,
	"./category/category-2.svg": 79384,
	"./category/category-20.jpg": 19778,
	"./category/category-21.jpg": 32447,
	"./category/category-22.jpg": 48112,
	"./category/category-23.jpg": 49037,
	"./category/category-24.jpg": 67590,
	"./category/category-25.jpg": 89763,
	"./category/category-26.jpg": 11636,
	"./category/category-27.jpg": 9009,
	"./category/category-28.jpg": 46954,
	"./category/category-29.jpg": 59111,
	"./category/category-3-old.svg": 33757,
	"./category/category-3.jpg": 77237,
	"./category/category-3.svg": 83625,
	"./category/category-30.jpg": 2937,
	"./category/category-4.jpg": 41614,
	"./category/category-4.svg": 54182,
	"./category/category-5.jpg": 19659,
	"./category/category-5.svg": 68567,
	"./category/category-6.jpg": 51356,
	"./category/category-6.svg": 25444,
	"./category/category-7.jpg": 21881,
	"./category/category-7.svg": 76613,
	"./category/category-8.jpg": 87394,
	"./category/category-8.svg": 31970,
	"./category/category-9.jpg": 79103,
	"./category/icons/icon-1.svg": 28853,
	"./category/icons/icon-10.svg": 46767,
	"./category/icons/icon-11.svg": 84190,
	"./category/icons/icon-2.svg": 87606,
	"./category/icons/icon-3.svg": 74727,
	"./category/icons/icon-4.svg": 54920,
	"./category/icons/icon-5.png": 7973,
	"./category/icons/icon-6.svg": 2090,
	"./category/icons/icon-7.svg": 36283,
	"./category/icons/icon-8.svg": 68668,
	"./category/icons/icon-9.svg": 39293,
	"./certificate-icon.svg": 28331,
	"./certificates/certificate-01.svg": 58218,
	"./certificates/certificate-02.svg": 18969,
	"./certificates/certificate-03.svg": 11048,
	"./chat-img-01.jpg": 82154,
	"./circle-icon.png": 28388,
	"./client/01.svg": 76295,
	"./client/02.svg": 11732,
	"./client/03.svg": 49717,
	"./client/04.svg": 20618,
	"./client/05.svg": 89435,
	"./client/06.svg": 73896,
	"./client/07.svg": 69913,
	"./client/08.svg": 69470,
	"./client/09.svg": 89519,
	"./client/10.svg": 12001,
	"./client/11.svg": 76464,
	"./client/12.svg": 33507,
	"./client/13.svg": 18866,
	"./client/14.svg": 52797,
	"./client/15.svg": 63324,
	"./client/16.svg": 42351,
	"./client/17.svg": 98622,
	"./client/18.svg": 57497,
	"./client/19.svg": 75752,
	"./client/20.svg": 29448,
	"./client/21.svg": 37369,
	"./client/22.svg": 92970,
	"./client/23.svg": 10811,
	"./client/24.svg": 77748,
	"./client/25.svg": 3381,
	"./client/26.svg": 62134,
	"./client/27.svg": 49255,
	"./client/client-01.svg": 40077,
	"./client/client-02.svg": 57102,
	"./client/client-03.svg": 71743,
	"./client/client-04.svg": 54272,
	"./client/client-05.svg": 68657,
	"./client/client-28.svg": 63554,
	"./client/client-29.svg": 68723,
	"./client/client-30.svg": 70997,
	"./client/client-31.svg": 9716,
	"./client/client-32.svg": 97575,
	"./client/client-33.svg": 58038,
	"./client/client-34.svg": 41721,
	"./client/client-35.svg": 59976,
	"./client/client-36.svg": 41339,
	"./client/client-37.svg": 99370,
	"./client/client-38.svg": 67645,
	"./cloud-icons.png": 2348,
	"./come-soon.png": 24918,
	"./comma-icon.png": 40817,
	"./company-img-1.png": 76551,
	"./company-img-2.png": 25868,
	"./company-img-3.png": 37493,
	"./company-img-4.png": 69082,
	"./company-img-5.png": 58915,
	"./company-img-6.png": 96936,
	"./cources-icon.svg": 41846,
	"./course-01.png": 62887,
	"./course-02.png": 95852,
	"./course-03.png": 7477,
	"./course-04.png": 55418,
	"./course-arrow.png": 54967,
	"./course-bg.png": 66779,
	"./course-img-1.jpg": 75955,
	"./course-img-2.jpg": 49732,
	"./course-img-3.jpg": 23329,
	"./course/add-course-1.jpg": 54171,
	"./course/course-01.jpg": 1951,
	"./course/course-01.svg": 7433,
	"./course/course-02.jpg": 87600,
	"./course/course-02.svg": 22970,
	"./course/course-03.jpg": 39821,
	"./course/course-03.svg": 53931,
	"./course/course-04.jpg": 20742,
	"./course/course-04.svg": 49252,
	"./course/course-05.jpg": 80227,
	"./course/course-06.jpg": 34164,
	"./course/course-07.jpg": 48497,
	"./course/course-08.jpg": 77386,
	"./course/course-09.jpg": 33223,
	"./course/course-10.jpg": 68825,
	"./course/course-11.jpg": 24476,
	"./course/course-12.jpg": 49643,
	"./course/course-13.jpg": 70158,
	"./course/course-14.jpg": 7221,
	"./course/course-15.jpg": 46040,
	"./course/course-16.jpg": 78887,
	"./course/course-17.jpg": 83082,
	"./course/course-18.jpg": 45137,
	"./course/course-19.jpg": 31412,
	"./course/course-20.jpg": 12296,
	"./course/course-21.jpg": 39909,
	"./course/course-22.jpg": 82682,
	"./course/course-23.jpg": 34615,
	"./course/course-24.jpg": 74380,
	"./course/course-25.jpg": 88521,
	"./course/course-26.jpg": 97022,
	"./course/course-27.jpg": 17179,
	"./course/course-28.jpg": 91872,
	"./course/course-29.jpg": 43613,
	"./course/course-30.jpg": 6151,
	"./course/course-31.jpg": 38410,
	"./course/course-32.jpg": 30485,
	"./course/course-33.jpg": 26168,
	"./course/course-34.jpg": 72907,
	"./course/course-35.jpg": 94862,
	"./course/course-36.jpg": 75129,
	"./course/course-37.jpg": 88252,
	"./course/course-38.jpg": 32351,
	"./course/course-39.jpg": 24290,
	"./course/course-40.jpg": 85198,
	"./course/course-41.jpg": 63243,
	"./course/course-42.jpg": 78588,
	"./course/course-43.jpg": 65465,
	"./course/course-44.jpg": 28746,
	"./course/course-45.jpg": 96487,
	"./course/course-46.jpg": 16504,
	"./course/course-47.jpg": 20821,
	"./course/course-48.jpg": 84006,
	"./course/course-bg-1.svg": 2163,
	"./course/course-bg-2.png": 14990,
	"./course/course-bg-2.svg": 11424,
	"./course/course-bg-3.svg": 68337,
	"./course/course-details-bg.jpg": 93748,
	"./course/course-details-two-1.jpg": 46449,
	"./course/course-details-two-2.jpg": 14246,
	"./course/courses-01.jpg": 42538,
	"./course/courses-02.jpg": 9877,
	"./course/courses-03.jpg": 2616,
	"./course/courses-04.jpg": 25451,
	"./course/courses-05.jpg": 98990,
	"./course/courses-06.jpg": 55129,
	"./course/featured-course-01.jpg": 32356,
	"./course/featured-course-02.jpg": 16051,
	"./course/featured-course-03.jpg": 60790,
	"./course/featured-course-04.jpg": 1309,
	"./course/featured-course-05.jpg": 92096,
	"./course/featured-course-06.jpg": 58735,
	"./course/video-bg.jpg": 48335,
	"./demo.png": 79753,
	"./deposit-01.jpg": 54342,
	"./deposit-02.jpg": 95761,
	"./deposit-03.jpg": 98388,
	"./deposit-04.jpg": 19199,
	"./deposit.png": 51748,
	"./developer-img-2.jpg": 7911,
	"./developer-img-3.png": 85998,
	"./developer-img.png": 47014,
	"./dotted-square-img.png": 65332,
	"./education-img-1.jpg": 19208,
	"./education-img-2.jpg": 41527,
	"./education.png": 7908,
	"./error-01.png": 66350,
	"./error-02.png": 38149,
	"./error-bg.png": 26305,
	"./error-bg1.png": 11733,
	"./error.png": 70051,
	"./error/coming-soon.svg": 10778,
	"./error/error-01.svg": 18761,
	"./error/error-02.svg": 76826,
	"./error/error-03.svg": 4472,
	"./error/error-bg.png": 14127,
	"./error/img-01.png": 87766,
	"./error/img-01.svg": 4116,
	"./error/img-02.png": 1741,
	"./error/img-02.svg": 91975,
	"./error/img-03.png": 47844,
	"./error/img-03.svg": 52438,
	"./error/img-04.png": 11707,
	"./error/img-04.svg": 36121,
	"./error/img-05.png": 96882,
	"./error/img-05.svg": 54376,
	"./error/img-06.png": 27849,
	"./error/img-06.svg": 35739,
	"./favicon.png": 90286,
	"./favicon.svg": 45278,
	"./favicon.webp": 98007,
	"./feature-img-1.jpg": 57688,
	"./feature-img-2.jpg": 37671,
	"./feature-img-3.jpg": 69930,
	"./feature-img-4.jpg": 6649,
	"./feature-instructor-img-1.png": 48646,
	"./feature-instructor-img-2.png": 89885,
	"./feature-instructor-img-3.png": 68756,
	"./feature-instructor-img-4.png": 14667,
	"./feature/feature-1.jpg": 75637,
	"./feature/feature-10.jpg": 45785,
	"./feature/feature-11.jpg": 24732,
	"./feature/feature-12.jpg": 33067,
	"./feature/feature-13.jpg": 55022,
	"./feature/feature-14.svg": 10019,
	"./feature/feature-15.svg": 95378,
	"./feature/feature-16.png": 51831,
	"./feature/feature-17.svg": 52976,
	"./feature/feature-18.jpg": 62353,
	"./feature/feature-19.jpg": 31668,
	"./feature/feature-2.jpg": 49386,
	"./feature/feature-20.jpg": 94760,
	"./feature/feature-21.jpg": 57125,
	"./feature/feature-22.png": 46910,
	"./feature/feature-23.jpg": 45335,
	"./feature/feature-24.jpg": 90988,
	"./feature/feature-25.jpg": 36361,
	"./feature/feature-26.jpg": 62654,
	"./feature/feature-27.jpg": 17435,
	"./feature/feature-28.jpg": 11968,
	"./feature/feature-3.jpg": 5223,
	"./feature/feature-4.jpg": 99228,
	"./feature/feature-5.jpg": 20281,
	"./feature/feature-6.jpg": 13166,
	"./feature/feature-7.png": 99795,
	"./feature/feature-8.jpg": 59600,
	"./feature/feature-9.jpg": 28173,
	"./featured-courses/Clip-path-group.svg": 81792,
	"./featured-courses/Ellipse-01.png": 12802,
	"./featured-courses/Ellipse-02.png": 77337,
	"./featured-courses/Ellipse-03.png": 80432,
	"./featured-courses/Ellipse-04.png": 23279,
	"./featured-courses/Star-05.png": 19494,
	"./featured-courses/adobexd.svg": 75977,
	"./featured-courses/card-bg.png": 65140,
	"./featured-courses/react.svg": 57993,
	"./female-student-img.png": 31164,
	"./figma-icon.png": 20862,
	"./flags/ad.png": 94663,
	"./flags/ae.png": 76350,
	"./flags/af.png": 43701,
	"./flags/africa.svg": 75568,
	"./flags/ag.png": 74604,
	"./flags/ai.png": 14546,
	"./flags/al.png": 1759,
	"./flags/am.png": 5430,
	"./flags/ao.png": 47108,
	"./flags/ar.png": 91553,
	"./flags/arab-flag.svg": 91285,
	"./flags/as.png": 6936,
	"./flags/at.png": 98455,
	"./flags/au.png": 39086,
	"./flags/australia.svg": 36688,
	"./flags/aw.png": 97820,
	"./flags/ax.png": 1419,
	"./flags/az.png": 28473,
	"./flags/ba.png": 17819,
	"./flags/bb.png": 20256,
	"./flags/bd.png": 94486,
	"./flags/be.png": 48287,
	"./flags/bf.png": 63012,
	"./flags/bg.png": 26253,
	"./flags/bh.png": 57018,
	"./flags/bi.png": 63203,
	"./flags/bj.png": 84872,
	"./flags/bl.png": 88702,
	"./flags/bm.png": 64487,
	"./flags/bn.png": 13804,
	"./flags/bo.png": 25429,
	"./flags/bq.png": 43499,
	"./flags/br.png": 78096,
	"./flags/brazil.svg": 63644,
	"./flags/bs.png": 10201,
	"./flags/bt.png": 5222,
	"./flags/bv.png": 67860,
	"./flags/bw.png": 88989,
	"./flags/by.png": 63155,
	"./flags/bz.png": 88664,
	"./flags/ca.png": 20276,
	"./flags/cc.png": 57638,
	"./flags/cd.png": 62617,
	"./flags/cf.png": 12267,
	"./flags/cg.png": 48610,
	"./flags/ch.png": 49477,
	"./flags/ci.png": 15612,
	"./flags/ck.png": 30702,
	"./flags/cl.png": 13793,
	"./flags/cm.png": 41080,
	"./flags/cn.png": 15571,
	"./flags/co.png": 64810,
	"./flags/cr.png": 703,
	"./flags/cu.png": 72672,
	"./flags/cv.png": 70235,
	"./flags/cw.png": 48690,
	"./flags/cx.png": 77845,
	"./flags/cy.png": 66220,
	"./flags/cz.png": 16903,
	"./flags/de.png": 5593,
	"./flags/dj.png": 32558,
	"./flags/dk.png": 32055,
	"./flags/dm.png": 31041,
	"./flags/do.png": 5523,
	"./flags/dz.png": 58366,
	"./flags/ec.png": 72676,
	"./flags/ee.png": 5938,
	"./flags/eg.png": 29920,
	"./flags/er.png": 98653,
	"./flags/es.png": 77524,
	"./flags/et.png": 53163,
	"./flags/fi.png": 26831,
	"./flags/fj.png": 7924,
	"./flags/fk.png": 29053,
	"./flags/flag.svg": 16744,
	"./flags/fm.png": 53835,
	"./flags/fo.png": 80889,
	"./flags/fr.png": 27020,
	"./flags/france-flag.svg": 9218,
	"./flags/ga.png": 73696,
	"./flags/gb.png": 35675,
	"./flags/gd.png": 25709,
	"./flags/ge.png": 71812,
	"./flags/gf.png": 8671,
	"./flags/gg.png": 11734,
	"./flags/gh.png": 89041,
	"./flags/gi.png": 78824,
	"./flags/gl.png": 91701,
	"./flags/gm.png": 55788,
	"./flags/gn.png": 58439,
	"./flags/gp.png": 53177,
	"./flags/gq.png": 46928,
	"./flags/gr.png": 77099,
	"./flags/gs.png": 86594,
	"./flags/gt.png": 48317,
	"./flags/gu.png": 10836,
	"./flags/gw.png": 50758,
	"./flags/gy.png": 57496,
	"./flags/hk.png": 5907,
	"./flags/hn.png": 21038,
	"./flags/hr.png": 39026,
	"./flags/ht.png": 5764,
	"./flags/hu.png": 69005,
	"./flags/id.png": 45535,
	"./flags/ie.png": 67446,
	"./flags/il.png": 30503,
	"./flags/im.png": 42814,
	"./flags/in.png": 28565,
	"./flags/io.png": 62028,
	"./flags/iq.png": 99778,
	"./flags/ir.png": 55865,
	"./flags/is.png": 49616,
	"./flags/it.png": 61839,
	"./flags/japan.svg": 10762,
	"./flags/je.png": 12727,
	"./flags/jm.png": 65391,
	"./flags/jo.png": 81405,
	"./flags/jp.png": 1018,
	"./flags/ke.png": 75208,
	"./flags/kg.png": 47354,
	"./flags/kh.png": 16589,
	"./flags/ki.png": 53348,
	"./flags/km.png": 10592,
	"./flags/kn.png": 8155,
	"./flags/kp.png": 87397,
	"./flags/kr.png": 58615,
	"./flags/kw.png": 2730,
	"./flags/ky.png": 58196,
	"./flags/kz.png": 80655,
	"./flags/la.png": 82037,
	"./flags/lb.png": 96286,
	"./flags/lc.png": 48775,
	"./flags/li.png": 16045,
	"./flags/lk.png": 99007,
	"./flags/lr.png": 70478,
	"./flags/ls.png": 53623,
	"./flags/lt.png": 47832,
	"./flags/lu.png": 68961,
	"./flags/lv.png": 11530,
	"./flags/ly.png": 38653,
	"./flags/ma.png": 22894,
	"./flags/mc.png": 98460,
	"./flags/md.png": 95859,
	"./flags/me.png": 63946,
	"./flags/mg.png": 248,
	"./flags/mh.png": 75055,
	"./flags/mk.png": 69940,
	"./flags/ml.png": 19851,
	"./flags/mm.png": 29346,
	"./flags/mn.png": 95929,
	"./flags/mo.png": 6032,
	"./flags/mp.png": 1191,
	"./flags/mq.png": 48702,
	"./flags/mr.png": 50805,
	"./flags/ms.png": 98540,
	"./flags/mt.png": 74787,
	"./flags/mu.png": 10682,
	"./flags/mv.png": 31793,
	"./flags/mw.png": 21576,
	"./flags/mx.png": 51423,
	"./flags/my.png": 54486,
	"./flags/mz.png": 68461,
	"./flags/na.png": 14255,
	"./flags/nc.png": 56445,
	"./flags/ne.png": 89675,
	"./flags/nf.png": 2032,
	"./flags/ng.png": 8281,
	"./flags/ni.png": 21943,
	"./flags/nl.png": 79850,
	"./flags/no.png": 10433,
	"./flags/norway.svg": 37668,
	"./flags/np.png": 19862,
	"./flags/nr.png": 84388,
	"./flags/nu.png": 94331,
	"./flags/nz.png": 14444,
	"./flags/om.png": 98260,
	"./flags/pa.png": 55953,
	"./flags/pe.png": 58613,
	"./flags/pf.png": 72862,
	"./flags/pg.png": 25351,
	"./flags/ph.png": 40608,
	"./flags/pk.png": 2587,
	"./flags/pl.png": 38724,
	"./flags/pm.png": 92621,
	"./flags/pn.png": 78646,
	"./flags/pr.png": 88106,
	"./flags/ps.png": 20019,
	"./flags/pt.png": 22620,
	"./flags/pw.png": 30199,
	"./flags/py.png": 20089,
	"./flags/qa.png": 40522,
	"./flags/re.png": 90831,
	"./flags/ro.png": 23301,
	"./flags/rs.png": 87049,
	"./flags/ru.png": 74527,
	"./flags/rw.png": 3469,
	"./flags/sa.png": 66436,
	"./flags/sb.png": 21087,
	"./flags/sc.png": 24758,
	"./flags/sd.png": 24585,
	"./flags/se.png": 47379,
	"./flags/sg.png": 33874,
	"./flags/sh.png": 63029,
	"./flags/si.png": 93932,
	"./flags/sk.png": 95678,
	"./flags/sl.png": 36689,
	"./flags/sm.png": 38824,
	"./flags/sn.png": 24099,
	"./flags/so.png": 6522,
	"./flags/sr.png": 93743,
	"./flags/ss.png": 54726,
	"./flags/st.png": 47801,
	"./flags/sv.png": 20747,
	"./flags/sx.png": 46565,
	"./flags/sy.png": 17148,
	"./flags/sz.png": 17783,
	"./flags/tc.png": 31775,
	"./flags/td.png": 73120,
	"./flags/tf.png": 79154,
	"./flags/tg.png": 28155,
	"./flags/th.png": 48268,
	"./flags/tj.png": 29054,
	"./flags/tk.png": 16743,
	"./flags/tl.png": 25224,
	"./flags/tm.png": 65169,
	"./flags/tn.png": 56858,
	"./flags/to.png": 78435,
	"./flags/tr.png": 9062,
	"./flags/tt.png": 35856,
	"./flags/tv.png": 86018,
	"./flags/tw.png": 7147,
	"./flags/tz.png": 26542,
	"./flags/ua.png": 61478,
	"./flags/ug.png": 88272,
	"./flags/um.png": 66090,
	"./flags/us-flag.svg": 72673,
	"./flags/us-one.png": 97791,
	"./flags/us.png": 70628,
	"./flags/us1.png": 50631,
	"./flags/uy.png": 81470,
	"./flags/uz.png": 67221,
	"./flags/va.png": 41063,
	"./flags/vc.png": 2005,
	"./flags/ve.png": 23427,
	"./flags/vg.png": 9841,
	"./flags/vi.png": 24863,
	"./flags/vn.png": 96832,
	"./flags/vu.png": 39731,
	"./flags/wf.png": 19311,
	"./flags/ws.png": 25266,
	"./flags/ye.png": 97478,
	"./flags/yt.png": 63839,
	"./flags/za.png": 59107,
	"./flags/zm.png": 12447,
	"./flags/zw.png": 61221,
	"./footer-background-img.png": 31358,
	"./footer-logo.png": 60317,
	"./gallery/gallery-1.jpg": 61813,
	"./gallery/gallery-2.jpg": 21322,
	"./gallery/gallery-3.jpg": 33479,
	"./gallery/gallery-4.jpg": 56687,
	"./gallery/gallery-5.jpg": 7065,
	"./gallery/gallery-6.jpg": 8398,
	"./gallery/gallery-7.jpg": 4235,
	"./gallery/gallery-8.jpg": 22480,
	"./gratuate-icon.svg": 40265,
	"./header-background-img.png": 81480,
	"./hero/hero-1.png": 75767,
	"./hero/hero-2.png": 17660,
	"./hero/hero-3.jpg": 21525,
	"./hero/hero-4.jpg": 85902,
	"./hero/hero-5.jpg": 63947,
	"./hero/hero-6.png": 26776,
	"./hero/hero-7.png": 47905,
	"./hero/hero-8.png": 29062,
	"./home-four-vector-left.svg": 18026,
	"./home-four-vector-right.svg": 51713,
	"./home-six-banner.jpg": 44543,
	"./home/home-01.jpg": 50935,
	"./home/home-02.jpg": 12264,
	"./home/home-03.jpg": 56229,
	"./home/home-04.jpg": 96990,
	"./home/home-05.jpg": 17147,
	"./home/home-06.jpg": 90700,
	"./icon-three/award.svg": 26704,
	"./icon-three/building.svg": 64298,
	"./icon-three/career-01.svg": 96721,
	"./icon-three/career-02.svg": 39618,
	"./icon-three/career-03.svg": 43347,
	"./icon-three/career-04.svg": 20780,
	"./icon-three/check-round-1.svg": 5014,
	"./icon-three/check-round-2.svg": 76885,
	"./icon-three/check-round-3.svg": 4276,
	"./icon-three/check-round.svg": 58008,
	"./icon-three/course-01.svg": 44698,
	"./icon-three/course-02.svg": 59785,
	"./icon-three/course-03.svg": 24920,
	"./icon-three/course-04.svg": 44727,
	"./icon-three/ellipse-1.svg": 36391,
	"./icon-three/ellipse-2.svg": 64884,
	"./icon-three/ellipse-3.svg": 90517,
	"./icon-three/email.svg": 22931,
	"./icon-three/search-icon.svg": 4533,
	"./icon-three/student-icon.svg": 42656,
	"./icon-three/student.svg": 9398,
	"./icon-three/time.svg": 19214,
	"./icon-three/winning.svg": 90563,
	"./icon/angry.svg": 82119,
	"./icon/anguish.svg": 44779,
	"./icon/angular-icon.svg": 67076,
	"./icon/app-store.svg": 8033,
	"./icon/appstore.svg": 62612,
	"./icon/award-new.svg": 30254,
	"./icon/award.svg": 72747,
	"./icon/badge.svg": 12841,
	"./icon/book-2.svg": 91434,
	"./icon/book-3.svg": 9275,
	"./icon/book-icon.svg": 62803,
	"./icon/book.svg": 60783,
	"./icon/bookmark.svg": 11376,
	"./icon/building.svg": 76760,
	"./icon/career-01.svg": 16134,
	"./icon/career-02.svg": 47909,
	"./icon/career-03.svg": 50660,
	"./icon/career-04.svg": 34603,
	"./icon/cart.svg": 13050,
	"./icon/certificate.svg": 17589,
	"./icon/certified-course-icon.svg": 14235,
	"./icon/chapter.svg": 59519,
	"./icon/chart.svg": 57416,
	"./icon/check-circle.svg": 42165,
	"./icon/check-round-1.svg": 38673,
	"./icon/check-round-2.svg": 74626,
	"./icon/check-round-3.svg": 88851,
	"./icon/check-round.svg": 31639,
	"./icon/clock.svg": 7010,
	"./icon/close-circle.svg": 29761,
	"./icon/cloud-icon-1.svg": 24361,
	"./icon/cloud-icon-2.svg": 56250,
	"./icon/cloud-icon-3.svg": 70859,
	"./icon/cloud-icon-4.svg": 66180,
	"./icon/cloud.svg": 29691,
	"./icon/company-logo-1.svg": 17421,
	"./icon/company-logo-2.svg": 34446,
	"./icon/company-logo-3.svg": 49087,
	"./icon/count-four.svg": 33482,
	"./icon/count-one.svg": 27002,
	"./icon/count-three.svg": 50994,
	"./icon/count-two.svg": 78820,
	"./icon/course-01.svg": 59097,
	"./icon/course-02.svg": 67722,
	"./icon/course-03.svg": 28091,
	"./icon/course-04.svg": 18324,
	"./icon/docker.svg": 89892,
	"./icon/document.svg": 33811,
	"./icon/dollar-circle.svg": 33735,
	"./icon/ellipse-1.svg": 79528,
	"./icon/ellipse-2.svg": 30267,
	"./icon/ellipse-3.svg": 69898,
	"./icon/email.svg": 32376,
	"./icon/expert-tutor-icon.svg": 87835,
	"./icon/favourite-01.svg": 82247,
	"./icon/favourite-02.svg": 94388,
	"./icon/favourite-03.svg": 36373,
	"./icon/favourite-04.svg": 9610,
	"./icon/favourite-05.svg": 43803,
	"./icon/fb-icon.svg": 37682,
	"./icon/figma.svg": 39764,
	"./icon/framework-01.svg": 84212,
	"./icon/framework-02.svg": 71156,
	"./icon/framework-03.svg": 85558,
	"./icon/framework-04.svg": 42393,
	"./icon/github-icon.svg": 75025,
	"./icon/google-icon.svg": 81777,
	"./icon/google-play.svg": 7928,
	"./icon/googleplay.svg": 35351,
	"./icon/graduation-hat-icon.svg": 68014,
	"./icon/graduation.svg": 24828,
	"./icon/heart.svg": 17324,
	"./icon/home-search-six.svg": 39813,
	"./icon/icon-01.svg": 25109,
	"./icon/icon-02.svg": 4822,
	"./icon/icon-03.svg": 51687,
	"./icon/icon-04.svg": 49288,
	"./icon/icon-05.svg": 45305,
	"./icon/icon-06.svg": 96010,
	"./icon/icon-07.svg": 64827,
	"./icon/icon-08.svg": 62588,
	"./icon/icon-09.svg": 91133,
	"./icon/icon-1.svg": 84557,
	"./icon/icon-10.svg": 47127,
	"./icon/icon-11.svg": 41798,
	"./icon/icon-12.svg": 89925,
	"./icon/icon-13.svg": 92676,
	"./icon/icon-14.svg": 60267,
	"./icon/icon-15.svg": 66394,
	"./icon/icon-16.svg": 27561,
	"./icon/icon-17.svg": 2200,
	"./icon/icon-18.svg": 12415,
	"./icon/icon-19.svg": 97774,
	"./icon/icon-2.svg": 55438,
	"./icon/icon-20.svg": 56642,
	"./icon/icon-21.svg": 61811,
	"./icon/icon-22.svg": 41056,
	"./icon/icon-23.svg": 77009,
	"./icon/icon-24.svg": 78510,
	"./icon/icon-25.svg": 6943,
	"./icon/icon-26.svg": 27916,
	"./icon/icon-27.svg": 26861,
	"./icon/icon-3.svg": 76543,
	"./icon/icon-4.svg": 17984,
	"./icon/import.svg": 58183,
	"./icon/joing-01.svg": 30665,
	"./icon/joing-02.svg": 15578,
	"./icon/joing-03.svg": 34635,
	"./icon/joing-04.svg": 72484,
	"./icon/key.svg": 61181,
	"./icon/lab-img-1.svg": 21793,
	"./icon/lab-img-10.svg": 95907,
	"./icon/lab-img-11.svg": 41618,
	"./icon/lab-img-2.svg": 40050,
	"./icon/lab-img-3.svg": 89443,
	"./icon/lab-img-4.svg": 61788,
	"./icon/lab-img-5.svg": 73981,
	"./icon/lab-img-6.svg": 61886,
	"./icon/lab-img-7.svg": 24463,
	"./icon/lab-img-8.svg": 66312,
	"./icon/lab-img-9.svg": 48057,
	"./icon/laravel-icon.svg": 56835,
	"./icon/like.svg": 82513,
	"./icon/lock.svg": 99877,
	"./icon/mail-2.svg": 99732,
	"./icon/master-skill-icon-1.svg": 4718,
	"./icon/master-skill-icon-2.svg": 33837,
	"./icon/master-skill-icon-3.svg": 54124,
	"./icon/master-skill-icon-4.svg": 38163,
	"./icon/message-text.svg": 51191,
	"./icon/messages.svg": 60668,
	"./icon/mobile.svg": 99014,
	"./icon/money-add.svg": 72298,
	"./icon/nord-js.svg": 28321,
	"./icon/notification.svg": 63965,
	"./icon/online-course-icon.svg": 10537,
	"./icon/online-course-img.svg": 58535,
	"./icon/online-student-icon.svg": 43943,
	"./icon/paypal-icon.svg": 64569,
	"./icon/people.svg": 80049,
	"./icon/php-course-icon.svg": 5232,
	"./icon/php.svg": 72664,
	"./icon/plane-icon.svg": 63464,
	"./icon/play-01.svg": 93758,
	"./icon/play-icon.svg": 3912,
	"./icon/play.svg": 72494,
	"./icon/python.svg": 27526,
	"./icon/qr.svg": 78993,
	"./icon/react.svg": 3149,
	"./icon/search-icon.svg": 90542,
	"./icon/sign-right-arrow.svg": 12782,
	"./icon/sign.svg": 58619,
	"./icon/skill-01.svg": 41649,
	"./icon/skill-02.svg": 4930,
	"./icon/skill-03.svg": 26451,
	"./icon/skill-04.svg": 92556,
	"./icon/smile.svg": 33524,
	"./icon/smily.svg": 51232,
	"./icon/spinner.svg": 4687,
	"./icon/spinner2.gif": 83060,
	"./icon/spinnerloading.gif": 79394,
	"./icon/student-icon.svg": 70117,
	"./icon/student.svg": 34065,
	"./icon/swift.svg": 57145,
	"./icon/teacher.svg": 28394,
	"./icon/time.svg": 323,
	"./icon/timer-icon.svg": 30655,
	"./icon/timer-start.svg": 2248,
	"./icon/timer.svg": 12635,
	"./icon/twitter-x-icon.svg": 52136,
	"./icon/user-graduate-icon.svg": 73361,
	"./icon/user-icon.svg": 61989,
	"./icon/user-octagon.svg": 4143,
	"./icon/user-tag.svg": 80126,
	"./icon/user-tick.svg": 71693,
	"./icon/users.svg": 5600,
	"./icon/video.svg": 13617,
	"./icon/voice.svg": 77094,
	"./icon/wallet.svg": 58591,
	"./icon/winning.svg": 12664,
	"./icon/wish.svg": 66037,
	"./icons/Mastercard.svg": 6251,
	"./icons/appstore.svg": 43787,
	"./icons/award-01.svg": 39814,
	"./icons/award-02.svg": 76037,
	"./icons/award-03.svg": 98020,
	"./icons/banner-book.svg": 83613,
	"./icons/banner-icon-01.svg": 51339,
	"./icons/banner-icon-02.svg": 12504,
	"./icons/banner-icon-03.svg": 47369,
	"./icons/banner-icon-04.svg": 44774,
	"./icons/be.svg": 60580,
	"./icons/benefit-icon-01.svg": 14722,
	"./icons/benefit-icon-02.svg": 35089,
	"./icons/benefit-icon-03.svg": 99136,
	"./icons/book.svg": 57796,
	"./icons/book2.svg": 71678,
	"./icons/book3.svg": 15407,
	"./icons/calendar.svg": 90681,
	"./icons/calendar2.svg": 81289,
	"./icons/card.svg": 83473,
	"./icons/category-1.svg": 48929,
	"./icons/category-10.svg": 42755,
	"./icons/category-11.svg": 28114,
	"./icons/category-2.svg": 43890,
	"./icons/category-3.svg": 47203,
	"./icons/category-4.svg": 49276,
	"./icons/category-5.svg": 77821,
	"./icons/category-6.svg": 31550,
	"./icons/category-7.svg": 51599,
	"./icons/category-8.svg": 35976,
	"./icons/category-9.svg": 48345,
	"./icons/category-icon1.svg": 28035,
	"./icons/category-icon10.svg": 24224,
	"./icons/category-icon11.svg": 64785,
	"./icons/category-icon12.svg": 84386,
	"./icons/category-icon2.svg": 16515,
	"./icons/category-icon3.svg": 83474,
	"./icons/category-icon4.svg": 17405,
	"./icons/category-icon5.svg": 88860,
	"./icons/category-icon6.svg": 67887,
	"./icons/category-icon7.svg": 5310,
	"./icons/category-icon8.svg": 97510,
	"./icons/category-icon9.svg": 9736,
	"./icons/chart.svg": 39189,
	"./icons/cloud-lightning.svg": 18695,
	"./icons/count-four.svg": 8089,
	"./icons/count-one.svg": 67367,
	"./icons/count-three.svg": 50007,
	"./icons/count-two.svg": 39093,
	"./icons/counter-icon1.svg": 85714,
	"./icons/counter-icon2.svg": 51105,
	"./icons/counter-icon3.svg": 52656,
	"./icons/counter-icon4.svg": 70127,
	"./icons/course-01.svg": 18136,
	"./icons/facebook.svg": 35623,
	"./icons/fb.svg": 19599,
	"./icons/figma.svg": 73829,
	"./icons/google.svg": 60366,
	"./icons/googleplay.svg": 39900,
	"./icons/how-it-works-1.svg": 35400,
	"./icons/how-it-works-2.svg": 16763,
	"./icons/how-it-works-3.svg": 74794,
	"./icons/icon-1.svg": 69170,
	"./icons/icon-10.svg": 2766,
	"./icons/icon-11.svg": 31199,
	"./icons/icon-12.svg": 52172,
	"./icons/icon-13.svg": 51117,
	"./icons/icon-14.svg": 80898,
	"./icons/icon-15.svg": 86067,
	"./icons/icon-16.svg": 65312,
	"./icons/icon-17.svg": 1265,
	"./icons/icon-18.svg": 3110,
	"./icons/icon-19.svg": 1143,
	"./icons/icon-2.svg": 57857,
	"./icons/icon-20.svg": 33155,
	"./icons/icon-21.svg": 18514,
	"./icons/icon-22.svg": 11649,
	"./icons/icon-23.svg": 76112,
	"./icons/icon-24.svg": 41999,
	"./icons/icon-25.svg": 98270,
	"./icons/icon-26.svg": 52445,
	"./icons/icon-27.svg": 62972,
	"./icons/icon-28.png": 20911,
	"./icons/icon-29.png": 52166,
	"./icons/icon-3.svg": 66736,
	"./icons/icon-30.svg": 71616,
	"./icons/icon-31.png": 24149,
	"./icons/icon-32.svg": 28898,
	"./icons/icon-33.svg": 16275,
	"./icons/icon-34.svg": 10060,
	"./icons/icon-4.svg": 76879,
	"./icons/icon-5.svg": 40478,
	"./icons/icon-6.svg": 3101,
	"./icons/icon-7.svg": 74556,
	"./icons/icon-8.svg": 76795,
	"./icons/icon-9.svg": 7978,
	"./icons/import.svg": 11304,
	"./icons/instagram.svg": 44493,
	"./icons/instructor-icon1.svg": 13389,
	"./icons/instructor-icon2.svg": 61889,
	"./icons/instructor-icon3.svg": 5375,
	"./icons/instructor-icon4.svg": 46816,
	"./icons/joing-01.svg": 61362,
	"./icons/joing-02.svg": 88782,
	"./icons/joing-03.svg": 75280,
	"./icons/joing-04.svg": 69071,
	"./icons/key.svg": 33656,
	"./icons/linkedin.svg": 41185,
	"./icons/meet-icon-1.svg": 84582,
	"./icons/meet-icon-2.svg": 83717,
	"./icons/monitor-mobbile.svg": 5796,
	"./icons/note.svg": 33795,
	"./icons/paypal-2.svg": 99567,
	"./icons/paypal.svg": 59942,
	"./icons/people.svg": 78758,
	"./icons/people2.svg": 22344,
	"./icons/people3.svg": 87737,
	"./icons/play.svg": 97749,
	"./icons/play2.svg": 80189,
	"./icons/play3.svg": 90716,
	"./icons/review.svg": 90759,
	"./icons/rupee.svg": 98070,
	"./icons/save-10.svg": 55222,
	"./icons/sign.svg": 33760,
	"./icons/stripe.svg": 16520,
	"./icons/subscribe-icon-01.svg": 55695,
	"./icons/subscribe-icon-02.svg": 76668,
	"./icons/tag.svg": 93186,
	"./icons/teacher.svg": 86203,
	"./icons/timer-start.svg": 43737,
	"./icons/timer-start2.svg": 6249,
	"./icons/timer-start3.svg": 2008,
	"./icons/verify-icon.svg": 73914,
	"./icons/visa-logo.svg": 65412,
	"./icons/vision-icon-01.svg": 38517,
	"./icons/vision-icon-02.svg": 97270,
	"./icons/vision-icon-03.svg": 84391,
	"./icons/vision-icon-04.svg": 64584,
	"./icons/x.svg": 95081,
	"./image 25.jpg": 8070,
	"./impressive-dev-img.png": 53419,
	"./inner-banner.jpg": 49375,
	"./instructor-img-1.png": 39945,
	"./instructor-img-2.png": 91762,
	"./instructor-img-3.png": 13307,
	"./instructor-img-4.png": 58500,
	"./instructor-img-5.png": 21741,
	"./instructor-profile-bg.jpg": 92413,
	"./instructor/address-icon.png": 46496,
	"./instructor/certificate-1.jpg": 3787,
	"./instructor/certificate-2.jpg": 78620,
	"./instructor/certificate-3.jpg": 22969,
	"./instructor/certificate-4.jpg": 20874,
	"./instructor/courses-icon.png": 33366,
	"./instructor/email-icon.png": 33584,
	"./instructor/instructor-01.jpg": 40275,
	"./instructor/instructor-01.png": 68187,
	"./instructor/instructor-02.jpg": 46116,
	"./instructor/instructor-02.png": 13152,
	"./instructor/instructor-03.jpg": 24161,
	"./instructor/instructor-03.png": 67977,
	"./instructor/instructor-04.jpg": 98674,
	"./instructor/instructor-04.png": 93718,
	"./instructor/instructor-05.jpg": 71055,
	"./instructor/instructor-06.jpg": 57440,
	"./instructor/instructor-07.jpg": 8573,
	"./instructor/instructor-08.jpg": 34302,
	"./instructor/instructor-09.jpg": 82139,
	"./instructor/instructor-10.jpg": 52813,
	"./instructor/instructor-11.jpg": 9360,
	"./instructor/instructor-12.jpg": 40671,
	"./instructor/instructor-13.jpg": 4322,
	"./instructor/instructor-14.jpg": 17233,
	"./instructor/instructor-15.jpg": 38708,
	"./instructor/instructor-16.jpg": 40515,
	"./instructor/instructor-17.jpg": 59462,
	"./instructor/instructor-18.jpg": 48693,
	"./instructor/instructor-19.jpg": 57784,
	"./instructor/instructor-bg-banner--.png": 4870,
	"./instructor/instructor-bg-banner.png": 6404,
	"./instructor/instructor-course-icon.svg": 59639,
	"./instructor/instructor-reviews-icon.svg": 27287,
	"./instructor/instructor-students-icon.svg": 34254,
	"./instructor/instructor-table-01.jpg": 5926,
	"./instructor/instructor-table-02.jpg": 63697,
	"./instructor/instructor-table-03.jpg": 85172,
	"./instructor/instructor-table-04.jpg": 87135,
	"./instructor/instructor-table-05.jpg": 67138,
	"./instructor/instructor.png": 12335,
	"./instructor/phone-icon.png": 35744,
	"./instructor/profile-avatar.jpg": 24777,
	"./instructor/review-icon.png": 4114,
	"./instructor/ttl-stud-icon.png": 89387,
	"./join.png": 24208,
	"./joing-us-skill.png": 92536,
	"./joing-us.png": 54280,
	"./latest-blog-img-1.jpg": 19272,
	"./latest-blog-img-2.jpg": 69847,
	"./latest-blog-img-3.jpg": 59034,
	"./lead-01.png": 5032,
	"./lead-02.png": 67011,
	"./lead-03.png": 77178,
	"./lead-04.png": 29237,
	"./lead-05.png": 17612,
	"./lead-06.png": 84647,
	"./login-bg.png": 68305,
	"./login-img.png": 55319,
	"./logo-white.svg": 64415,
	"./logo.png": 65549,
	"./logo.svg": 67503,
	"./logo/favicon.ico": 38649,
	"./logo/logo-five.png": 88750,
	"./logo/logo-five.svg": 30892,
	"./logo/logo.png": 89899,
	"./logo/logo.svg": 32811,
	"./logo1.png": 23280,
	"./male-student-img.png": 50611,
	"./male-with-laptop-img.png": 11915,
	"./master-skill-img-1.png": 39782,
	"./master-skill-img-2.png": 20989,
	"./master-skill-img-3.png": 99860,
	"./net-icon-01.png": 20881,
	"./net-icon-02.png": 99770,
	"./net-icon-03.png": 47523,
	"./net-icon-04.png": 87628,
	"./news-event-img-1.jpg": 51482,
	"./news-event-rounded-img-1.png": 96782,
	"./news-event-rounded-img-2.png": 68581,
	"./news-event-rounded-img-3.png": 39164,
	"./nextlogo.jpg": 97506,
	"./nextsensecerti.png": 51474,
	"./object.png": 19621,
	"./pencil-icon.svg": 72409,
	"./plan.png": 39509,
	"./profile-bg.jpg": 71237,
	"./profiles/avatar-01.jpg": 54802,
	"./profiles/avatar-02.jpg": 92605,
	"./profiles/avatar-03.jpg": 24512,
	"./profiles/avatar-04.jpg": 14675,
	"./profiles/avatar-05.jpg": 86262,
	"./profiles/avatar-06.jpg": 62049,
	"./profiles/avatar-07.jpg": 88452,
	"./profiles/avatar-08.jpg": 83607,
	"./profiles/avatar-09.jpg": 31674,
	"./profiles/avatar-10.jpg": 16880,
	"./profiles/avatar-11.jpg": 17805,
	"./profiles/avatar-12.jpg": 88546,
	"./profiles/avatar-13.jpg": 1215,
	"./profiles/img1.png": 32741,
	"./profiles/img2.png": 60942,
	"./profiles/img3.png": 3959,
	"./profiles/img4.png": 28792,
	"./profiles/img5.png": 97057,
	"./profiles/img6.png": 48074,
	"./profiles/profile-01.png": 89149,
	"./profiles/profile-02.png": 60513,
	"./profiles/profile-03.png": 87800,
	"./profiles/profile-04.png": 67415,
	"./profiles/profile-05.png": 77422,
	"./profiles/profile-06.png": 96197,
	"./profiles/profile-07.png": 78684,
	"./profiles/profile-08.png": 58987,
	"./profiles/profile-09.png": 95330,
	"./profiles/profile-10.png": 41083,
	"./profiles/profile-11.png": 73681,
	"./profiles/profile-12.png": 52570,
	"./profiles/profile-13.png": 16675,
	"./profiles/profile-14.png": 40428,
	"./profiles/profile-15.png": 76341,
	"./profiles/profile-16.png": 90590,
	"./profiles/profile-17.png": 43079,
	"./qute-01.png": 96007,
	"./qute.png": 73339,
	"./react-icon.png": 19661,
	"./register-img.png": 99345,
	"./reviews-img-icon.svg": 67767,
	"./reviews-img-two.png": 93414,
	"./right-arrow.svg": 2916,
	"./send-icon.svg": 17042,
	"./service-01.png": 30795,
	"./service-02.png": 77296,
	"./shapes/about-shape1.png": 30463,
	"./shapes/about-shape2.png": 75812,
	"./shapes/about-shape3.png": 15757,
	"./shapes/bg-1.png": 63920,
	"./shapes/bg-2.png": 33771,
	"./shapes/bg-3.png": 12642,
	"./shapes/dot-2.svg": 35953,
	"./shapes/dot-group.png": 95072,
	"./shapes/half-circle.svg": 36541,
	"./shapes/instructor-bg-1.png": 9314,
	"./shapes/instructor-bg-2.png": 92249,
	"./shapes/quote.png": 33055,
	"./shapes/shape-1.svg": 10132,
	"./shapes/shape-10.svg": 98124,
	"./shapes/shape-11.svg": 97069,
	"./shapes/shape-2.svg": 81639,
	"./shapes/shape-3.png": 7336,
	"./shapes/shape-4.png": 82503,
	"./shapes/shape-5.png": 11166,
	"./shapes/shape-6.png": 96917,
	"./shapes/shape-7.svg": 99786,
	"./shapes/shape-8.png": 93915,
	"./shapes/shape-9.png": 44914,
	"./shapes/withdraw-bg1.svg": 40468,
	"./shapes/withdraw-bg2.svg": 88679,
	"./share.png": 43475,
	"./skil-01.png": 87337,
	"./skills/skill-01.jpg": 67662,
	"./skills/skill-02.jpg": 47929,
	"./skills/skill-03.jpg": 77404,
	"./skills/skill-04.jpg": 78951,
	"./skills/skills-01.jpg": 58941,
	"./skills/skills-01.svg": 77515,
	"./skills/skills-02.jpg": 23634,
	"./skills/skills-02.svg": 22328,
	"./skills/skills-03.jpg": 15,
	"./skills/skills-03.svg": 57193,
	"./skills/skills-04.svg": 70950,
	"./slider/home-slider-2.png": 58338,
	"./slider/home-slider.png": 63855,
	"./slider/home-three-banner-1.jpg": 32258,
	"./slider/home-three-banner.jpg": 12571,
	"./slider/slider-01.png": 73375,
	"./slider/slider-02.png": 18724,
	"./small-arrow-img.png": 97233,
	"./small-hat-img.png": 42549,
	"./spheres.png": 12944,
	"./students/award-01.png": 76528,
	"./students/book.svg": 40258,
	"./students/career.png": 74947,
	"./students/certification.png": 53319,
	"./students/empty-wallet-change.svg": 73575,
	"./students/empty-wallet-tick.svg": 90996,
	"./students/learn-anything.png": 49216,
	"./students/loc-icon.svg": 1321,
	"./students/profile-avatar.png": 702,
	"./students/profile-user.svg": 12648,
	"./students/quiz.jpg": 38010,
	"./students/receipt-text.svg": 4005,
	"./students/refer-img1.png": 81636,
	"./students/refer-img10.png": 36286,
	"./students/refer-img2.png": 95199,
	"./students/refer-img3.png": 17110,
	"./students/refer-img4.png": 91369,
	"./students/refer-img5.png": 36544,
	"./students/refer-img6.png": 91579,
	"./students/refer-img7.png": 26226,
	"./students/refer-img8.png": 78229,
	"./students/refer-img9.png": 95340,
	"./students/skill-01.jpg": 72744,
	"./students/skill-02.jpg": 41143,
	"./students/student-01.jpg": 48570,
	"./students/student-02.jpg": 71173,
	"./students/student-03.jpg": 8808,
	"./students/student-04.jpg": 31483,
	"./students/student-05.jpg": 60350,
	"./students/student-06.jpg": 50409,
	"./students/student-07.jpg": 88684,
	"./students/student-08.jpg": 39631,
	"./students/student-09.jpg": 71698,
	"./students/student-10.jpg": 7320,
	"./students/student-11.jpg": 15189,
	"./students/student-12.jpg": 88938,
	"./students/student-bg-banner.png": 24327,
	"./students/student.png": 80352,
	"./students/ticket-close.svg": 99330,
	"./students/ticket-open.svg": 98782,
	"./students/ticket-total.svg": 32308,
	"./support-bg.png": 28067,
	"./testimonial-background-img-1.png": 10918,
	"./testimonial-background-img-2.png": 14506,
	"./testimonial-img-1.jpg": 35771,
	"./testimonial-img-2.jpg": 92972,
	"./testimonial-img-3.jpg": 31017,
	"./testimonial/testimonial-01.png": 10959,
	"./testimonial/testimonial-02.png": 88500,
	"./testimonial/testimonial-03.png": 9629,
	"./testimonial/testimonials-1.png": 60110,
	"./tick-icon.svg": 41353,
	"./top-category-img-1.png": 94170,
	"./top-category-img-2.png": 24337,
	"./top-category-img-3.png": 26472,
	"./top-category-img-4.png": 1639,
	"./top-category-img-5.png": 83326,
	"./top-category-img-6.png": 50677,
	"./trend-bg.png": 61187,
	"./trending-course-img-1.jpg": 60593,
	"./trending-course-img-2.jpg": 28390,
	"./trending-course-img-3.jpg": 18499,
	"./user-bg-01.png": 67817,
	"./user-bg-02.png": 36850,
	"./user-love.jpg": 11156,
	"./user/user-01.jpg": 25155,
	"./user/user-02.jpg": 79092,
	"./user/user-03.jpg": 50897,
	"./user/user-04.jpg": 65666,
	"./user/user-05.jpg": 73727,
	"./user/user-06.jpg": 90000,
	"./user/user-07.jpg": 34893,
	"./user/user-08.jpg": 36238,
	"./user/user-09.jpg": 14283,
	"./user/user-10.jpg": 91293,
	"./user/user-11.jpg": 40160,
	"./user/user-12.jpg": 53775,
	"./user/user-13.jpg": 81394,
	"./user/user-14.jpg": 6881,
	"./user/user-15.jpg": 28836,
	"./user/user-16.jpg": 22995,
	"./user/user-17.jpg": 36534,
	"./user/user-18.jpg": 62021,
	"./user/user-19.jpg": 34856,
	"./user/user-20.jpg": 42604,
	"./user/user-21.jpg": 14217,
	"./user/user-22.jpg": 18270,
	"./user/user-23.jpg": 19579,
	"./user/user-24.jpg": 37992,
	"./user/user-25.jpg": 65605,
	"./user/user-26.jpg": 77754,
	"./user/user-27.jpg": 48919,
	"./user/user-28.jpg": 77060,
	"./user/user-29.jpg": 55105,
	"./user/user-30.jpg": 17835,
	"./user/user-31.jpg": 39790,
	"./user/user-32.jpg": 46905,
	"./user/user-33.jpg": 25852,
	"./user/user-34.jpg": 31847,
	"./user/user-35.jpg": 76010,
	"./user/user-36.jpg": 2261,
	"./user/user-37.jpg": 94392,
	"./user/user-38.jpg": 78851,
	"./user/user-39.jpg": 19366,
	"./user/user-40.jpg": 35642,
	"./user/user-41.jpg": 30103,
	"./user/user-42.jpg": 95880,
	"./user/user-43.jpg": 58245,
	"./user/user-44.jpg": 47422,
	"./user/user-45.jpg": 18555,
	"./user/user-46.jpg": 75756,
	"./user/user-47.jpg": 21129,
	"./user/user-48.jpg": 58770,
	"./user/user-49.jpg": 26703,
	"./user/user-50.jpg": 96177,
	"./user/user-51.jpg": 82452,
	"./user/user-52.jpg": 76931,
	"./user/user-53.jpg": 38406,
	"./user/user-54.jpg": 19853,
	"./user/user-55.jpg": 35280,
	"./user/user-56.jpg": 3263,
	"./user/user-57.jpg": 6946,
	"./user/user-61.jpg": 94653,
	"./user/user-62.jpg": 56850,
	"./user/user-63.jpg": 33231,
	"./user/user.jpg": 8655,
	"./user/user1.jpg": 37826,
	"./user/user10.jpg": 99696,
	"./user/user10.png": 88852,
	"./user/user11.jpg": 43149,
	"./user/user12.jpg": 11010,
	"./user/user13.jpg": 31007,
	"./user/user14.jpg": 29044,
	"./user/user15.jpg": 7569,
	"./user/user16.jpg": 49798,
	"./user/user2.jpg": 7053,
	"./user/user3.jpg": 62160,
	"./user/user4.jpg": 80963,
	"./user/user5.jpg": 90854,
	"./user/user6.jpg": 23057,
	"./user/user7.jpg": 34900,
	"./user/user7.png": 62000,
	"./user/user8.jpg": 3335,
	"./user/user8.png": 81911,
	"./user/user9.jpg": 51946,
	"./user/user9.png": 52686,
	"./vector-green-img.png": 9909,
	"./vector-img-1.png": 22729,
	"./vector-img-2.png": 69381,
	"./vector-img-3.png": 6587,
	"./vector-img-4.png": 42724,
	"./vector-img-5.png": 96621,
	"./video-bg.jpg": 9223,
	"./video-img-01.jpg": 96893,
	"./video.jpg": 67935,
	"./white-dotted.svg": 16902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;